export default __webpack_public_path__ + "static/media/jadwal-opname.36edb043.png";